import React from 'react';
import ReactDOM from 'react-dom';
import Auth from '../../services/auth-service.js';
import { useAuth0 } from '@auth0/auth0-react';


export class Login extends React.Component {
    render() {
      const { user, loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();

      if (isLoading) return <div>Loading...</div>;

      return isAuthenticated ? (
        <div>
          <h2>Welcome, {user.name}</h2>
          <button onClick={() => logout({ returnTo: window.location.origin })}>Logout</button>
        </div>
      ) : (
        <button onClick={loginWithRedirect}>Login</button>
      );
      
      var display = "";
      if( this.props.location.query == null ){
        const auth = new Auth();
        auth.login();
      }else{
        display = this.props.location.query;
      }

      return (
        <div>{display}</div>
      );
    }
}
  
